export const debtHandbookFields = {
  BASE_VALUES: "BASE_VALUES",
  AVG_REGION_INCOME: "AVG_REGION_INCOME",
  AVG_INDUSTRY_INCOME: "AVG_INDUSTRY_INCOME",
};

export const debtGroupKeys = {
  [debtHandbookFields.BASE_VALUES]: "Справочник базовой величины",
  [debtHandbookFields.AVG_INDUSTRY_INCOME]: "Справочник по отраслям",
  [debtHandbookFields.AVG_REGION_INCOME]: "Справочник средней заработной платы и пенсии",
};

export const modalTitles = {
  [debtHandbookFields.AVG_INDUSTRY_INCOME]: 'Редактирование справочника по отраслям экономики',
  [debtHandbookFields.BASE_VALUES]: 'Редактирование базовой величины',
  [debtHandbookFields.AVG_REGION_INCOME]: 'Редактирование справочника средней заработной платы и пенсии',
};

export const formatNumberInput = (value) => {
  const num = Number(value);
  return isNaN(num) ? "" : num.toFixed(2);
};